import React from 'react';
import Color from 'color';
import GoogleFont from 'react-google-font-loader';
import { makeStyles } from '@material-ui/core/styles';
import NoSsr from '@material-ui/core/NoSsr';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { useFourThreeCardMediaStyles } from '@mui-treasury/styles/cardMedia/fourThree';
import chess from './chess.png'
import decryptor from './decryptor.jpeg'
import splendor from "./splendor.jpg"
 

const useGridStyles = makeStyles(({ breakpoints }) => ({
  root: {
    [breakpoints.up('md')]: {
      justifyContent: 'center',
    },
  },
}));

const useStyles = makeStyles(() => ({
  actionArea: {
    borderRadius: 16,
    transition: '0.2s',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  card: ({ color }) => ({
    minWidth: 250,
    borderRadius: 16,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: `0 6px 12px 0 ${Color(color)
        .rotate(-12)
        .darken(0.2)
        .fade(0.5)}`,
    },
  }),
  content: ({ color }) => {
    return {
      backgroundColor: color,
      padding: '1rem 1.5rem 1.5rem',
    };
  },
  title: {
    fontFamily: 'Keania One',
    fontSize: '1.5rem',
    color: '#fff',
    textTransform: 'uppercase',
  },
  subtitle: {
    fontFamily: 'Montserrat',
    color: '#fff',
    opacity: 0.87,
    marginTop: '0.1rem',
    fontWeight: 500,
    fontSize: 14,
  },
}));

const CustomCard = ({ classes, image, title, subtitle }) => {
  const mediaStyles = useFourThreeCardMediaStyles();
  return (
    <CardActionArea className={classes.actionArea}>
      <Card className={classes.card}>
        <CardMedia classes={mediaStyles} image={image} />
        <CardContent className={classes.content}>
          <Typography className={classes.title} variant={'h2'}>
            {title}
          </Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </CardContent>
      </Card>
    </CardActionArea>
  );
};

export const SolidGameCardDemo = React.memo(function SolidGameCard(props) {
  const gridStyles = useGridStyles();
  const styles = useStyles({ color:  '#ff9933' });
  const styles2 = useStyles({ color: '#994d00' });
  const styles3 = useStyles({ color: '#000099' });
  const styles4 = useStyles({ color: '#000033' });

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}


  return (
    <>
    <h2>Overview of selected projects</h2>
    <br/>
      <Grid   container
  direction="row"
  justify="space-evenly"
  alignItems="center"
  wrap={'nowrap'}
  spacing={2}>
        <Grid item xs={3}>
          <CustomCard
          onClick={event => openInNewTab("https://onlineboggle.web.app/")}
            classes={styles}
            title={'Boggle!'}
            subtitle={'My online multiplayer implementation of boggle! (click to try)'}
            image={
              props.img_src
            }
          />
        </Grid>
        <Grid item xs={3}>
          <CustomCard
           onClick={event => openInNewTab("https://github.com/vivekmthr/Chess-Engine-In-C")}
            classes={styles2}
            title={'Chess Engine'}
            subtitle={'Building a chess engine with a bitboard base. (See github)'}
            image={
              chess
            }
          />
        </Grid>
        <Grid item xs={3}>
          <CustomCard
           onClick={event => openInNewTab("https://github.com/vivekmthr/Decryptor")}
            classes={styles3}
            title={'Decryptor'}
            subtitle={'Uses letter frequency analysis to crack ciphers. (see github)'}
            image={decryptor}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomCard
           onClick={event => openInNewTab("https://github.com/vivekmthr/Splendor-Clone")}
            classes={styles4}
            title={'Splendor'}
            subtitle={'Built and OOP clone of the boardgame splendor in C++. (See github)'}
            image={
              splendor
            }
          />
        </Grid>

      </Grid>
    </>
  );
});
export default SolidGameCardDemo